// extracted by mini-css-extract-plugin
export default {"smsContent":"SentSmsReport_smsContent__545Uj"};